// cacheHelper.js
export function transformCandidateArray(data) {
 if (!Array.isArray(data) || data.length === 0) return {};

  const first = data[0];

  return {
    candidateName: first?.candidatename ?? null,
    candidateid: first?.candidateid ?? null
  };
}
export const cacheTTL = 1 * 60 * 1000;
export const getCacheWithExpiry = (key) => {
  const itemStr = sessionStorage.getItem(key);

  if (!itemStr) return null;

  try {
    // console.log(itemStr,"itemstr consloed")
    const item = JSON.parse(itemStr); 
    const now = new Date();
    if (now.getTime() > item.expiry) {
      sessionStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch (e) {
    sessionStorage.removeItem(key);
    return null;
  }
};

export const setCacheWithExpiry = (key, value, ttl) => {
  const now = new Date();
  const item = {
    value,
    expiry: now.getTime() + ttl,
  };
  sessionStorage?.setItem(key, JSON?.stringify(item));
};
